"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OcapiShopperOrders = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _utils = require("./utils");
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// This class allows integration with OCAPI Orders Resource
// https://documentation.b2c.commercecloud.salesforce.com/DOC2/topic/com.demandware.dochelp/OCAPI/current/shop/Resources/Orders.html
// This implementations coverts CAPI requests to OCAPI requests as there are fundamental differences between the APIS
// One major difference is OCAPI uses snake_case and CAPI uses camelCase for this reaso you will see a utility function in here that convert
// from camelCase to snake_case - camelCaseKeysToUnderscore
// createOcapiFetch is another utility function that returns the response from OCAPI in the fromat returned from CAPI
// Another utility function - checkRequiredParameters is used to check if the parameters or body objects necessary for a call are
// present in the request before making it

class OcapiShopperOrders {
  constructor(config) {
    this.fetch = (0, _utils.createOcapiFetch)(config);
  }
  createOrder(...args) {
    var _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['body'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      const {
        body
      } = args[0];
      // @ts-ignore
      return yield _this.fetch('orders', 'POST', args, 'createOrder', (0, _utils.camelCaseKeysToUnderscore)(body));
    })();
  }
  getOrder(...args) {
    var _this2 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['orderNo'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      const {
        orderNo
      } = args[0].parameters;
      // @ts-ignore
      return _this2.fetch(`orders/${orderNo}`, 'GET', args, 'getOrder');
    })();
  }
}
exports.OcapiShopperOrders = OcapiShopperOrders;